module.exports = __webpack_public_path__ + "img/open-menu.4aaf92d0.svg";